// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import type { AutomationsAutomation } from '../types';
import { createQueryKey } from '../utils/keys';

// ---------------------------------------------------------------
// Mutation Keys
// ---------------------------------------------------------------
export const postAutomationsMutationKey = ['postAutomations'] as const;
export const runAutomationsMutationKey = ['runAutomations'] as const;
export const deleteAutomationsMutationKey = ['deleteAutomations'] as const;
export const updateAutomationsMutationKey = ['updateAutomations'] as const;

// ---------------------------------------------------------------
// Query Keys
// ---------------------------------------------------------------
export const getAutomationsListQueryKey = (
  workspace_id: number,
  opening_id: number
) =>
  createQueryKey<AutomationsAutomation[]>()([
    'workspaces',
    workspace_id,
    'openings',
    opening_id,
    'automations',
  ] as const);
